import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import LessonStep from './LessonStep';

const { FiGrid } = FiIcons;

function getSubjectProgress(lessons) {
  if (!lessons.length) return 0;

  const totalProgress = lessons.reduce((total, lesson) => {
    if (lesson.status === 'completed') return total + 100;
    if (lesson.status === 'in-progress') {
      return total + Math.max(lesson.progress || 0, 0);
    }
    return total;
  }, 0);

  return Math.round(totalProgress / lessons.length);
}

function SubjectProgress({ lessons }) {
  const progress = getSubjectProgress(lessons);

  return (
    <div className="subject-progress">
      <div className="subject-progress-copy">
        <span>Subject progress</span>
        <strong>{progress}%</strong>
      </div>
      <div
        aria-label={`Subject progress: ${progress}%`}
        aria-valuemax="100"
        aria-valuemin="0"
        aria-valuenow={progress}
        className="subject-progress-track"
        role="progressbar"
      >
        <span style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
}

function CurriculumPath({
  subjects,
  activeLessonId,
  onSelectLesson
}) {
  return (
    <aside className="curriculum-path">
      <div className="sidebar-heading">
        <span className="eyebrow">
          <SafeIcon icon={FiGrid} />
          Curriculum path
        </span>
        <h2>What are we learning?</h2>
        <p>Your curriculum unlocks one lesson at a time.</p>
      </div>

      <div className="subject-groups">
        {subjects.map((group) => (
          <div className="subject-group" key={group.subject}>
            <div className="subject-group-heading">
              <span className={`subject-dot ${group.subject.toLowerCase()}`} />
              <h3>{group.subject}</h3>
            </div>

            <SubjectProgress lessons={group.lessons} />

            <div className="lesson-steps">
              {group.lessons.map((lesson, index) => (
                <LessonStep
                  isActive={lesson.id === activeLessonId}
                  isLast={index === group.lessons.length - 1}
                  key={lesson.id}
                  lesson={lesson}
                  onSelect={onSelectLesson}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="sidebar-note">
        <span>Today’s reminder</span>
        <p>
          Being stuck means your brain is getting ready to learn something new.
        </p>
      </div>
    </aside>
  );
}

export default CurriculumPath;